<cm-sidebar-layout>
    <cm-item-filters cm-filters>
        <cm-search-filter placeholder="Name, organization name, ..."></cm-search-filter>
        <cm-checkboxes-filter label="Organizations" name="organizationId" [options]="organizations.$filterOptions()"></cm-checkboxes-filter>
    </cm-item-filters>
    <cm-hdris-grid></cm-hdris-grid>
</cm-sidebar-layout>
<router-outlet></router-outlet>
